import React, { useState, useEffect } from "react";
import { Table } from "@veneer/core";
import Swal from "sweetalert2";
import ConnectAPI from "../../../services/api";
import SpecialConditionDetailTypes2_12 from "./SpecialConditionDetailTypes2_12";

const connectApi = new ConnectAPI();
// 7 - Combine Clicks 
function SpecialConditionDetailTypes_7({ specialCondition }) {
    const [combineClicksTableData, setCombineClicksTableData] = useState([]);
    var fetchData;
    useEffect(() => {
        fetchData = async () => {
            connectApi.getWithParams("api/Channels/specialConditionCombineClicks", specialCondition.idSpecialCondition, getSCdataCallback)
                .catch((error) => {
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                    );
                });
        }
        fetchData();
    }, [specialCondition.idSpecialCondition]);
    let getSCdataCallback;
    getSCdataCallback = (status, data) => {
        setCombineClicksTableData(data);
    }
    const specialConditionBonusAndEPM = () => {
        if (specialCondition.idSpecialConditionType == 8 || specialCondition.idSpecialConditionType==17) {
            return <SpecialConditionDetailTypes2_12 specialCondition={specialCondition} />
        }
    }

    const tiersUp = () => {
        if (specialCondition.specialConditionTypeId == 19) {
            return specialCondition.percentage;
        }
    }
    const combineClicksTable = () => {
        return <Table
            columns={[
                {
                    id: 'endUserName',
                    label: 'Enduser Name',
                },
            ]}
            data={combineClicksTableData}
        ></Table>
    }

    return (<>
        {combineClicksTable()}
        {specialConditionBonusAndEPM()}
        {tiersUp()}
    </>);
}

export default SpecialConditionDetailTypes_7;